import {ImportFileProcess} from './import-file-process';

export class ImportListener {
  processes: ImportFileProcess[];
  pending = false;
  completed = false;
}
